import { render } from "./OnboardingQuicktrial.vue?vue&type=template&id=074c7ac6"
import script from "./OnboardingQuicktrial.vue?vue&type=script&lang=js"
export * from "./OnboardingQuicktrial.vue?vue&type=script&lang=js"

import "./OnboardingQuicktrial.vue?vue&type=style&index=0&id=074c7ac6&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__